import {Link} from 'react-router'

const statesFor = ({count, current}) => {
  const states = []
  for (let i = 0; i < count; ++i) {
    states.push(i < current ? 'past' : i > current ? 'future' : 'present')
  }
  return states
}

export const Pager = ({count, current, skipTo: skipToPath}) => (
  <div className="pager">
    <div className="pages">
      {statesFor({count, current}).map((state, i) =>
        <span className={`page ${state}`} key={i} />
      )}
    </div>
    <div className="skip">
      {current >= count - 1 ? null :
        <Link className='size-s' to={skipToPath}>Skip</Link>
      }
    </div>
  </div>
)
